import axiosInstance from "./authentication/axiosInstance";

export const clientServices = {
  // getClientData: async (search, page, size) => {
  //   const response = await axiosInstance.get(`/clients?search=${search}&pageNo=${page}&size=${size}`);
  //   return response.data;
  // },

  getClientData: async (search, filter, page, size, sortField, sortDir) => {
    const params = new URLSearchParams({
      search: search || '',
      filter: filter || '',
      pageNo: page,
      size: size,
      sortField: sortField || 'updatedAt',
      sortDir: sortDir || 'desc'
    }).toString();

    const response = await axiosInstance.get(`/clients?${params}`);
    return response.data;
  },

  getClientDataFromId: async (clientId) => {
    const response = await axiosInstance.get(`/clients/${clientId}`);
    return response.data;
  },

  postClientData: async (formData) => {
    const response = await axiosInstance.post("/clients", formData);
    return response.data;
  },

  deleteClientData: async (clientId) => {
    const response = await axiosInstance.delete(`/clients/${clientId}`);
    return response.data;
  },

  updateClientData: async (formData) => {
    const response = await axiosInstance.put("/clients", formData);
    return response.data;
  },
};
